import { useCallback } from 'react';

import { AddchartOutlined } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';

import { useWidgetAnimation } from '@/features/Dashboard/context/WidgetAnimation/hooks';
import { MarketApps } from '@/features/Dashboard/types';
import { useDashboard, useUpdateDashboard } from '@/hooks/api/dashboard';
import WidgetAdapter from '@/pages/Markets/utils/WidgetAdapter';
import { BaseTabType } from '@/slices/marketsSlice';

const AddToDashboardButton = ({ tab }: { tab: BaseTabType }) => {
  const { data: allDashboards } = useDashboard();

  const dashboardName = Object.keys(allDashboards || {})[0];

  const { mutate, isPending } = useUpdateDashboard(dashboardName, 'Market widget added!');

  const { setElementsToAnimateId } = useWidgetAnimation();

  const handleSave = useCallback(() => {
    if (isPending || !tab) return;

    let name = tab.name;
    if (!name && tab?.type === 'feed') {
      name = 'Feed';
    }
    const widget = WidgetAdapter.newWidget({ ...tab, name });

    const dashboardConfig = allDashboards?.[dashboardName];
    if (dashboardConfig) {
      mutate([...dashboardConfig, widget] as MarketApps);
    } else {
      mutate([widget] as MarketApps);
    }
    setElementsToAnimateId([widget?.id || '']);
  }, [isPending, tab, allDashboards, dashboardName, setElementsToAnimateId, mutate]);
  return (
    <Tooltip
      slotProps={{
        popper: {
          sx: { zIndex: 9999 }
        }
      }}
      title='Add widget to My Dashboard'
    >
      <IconButton
        sx={{
          width: 30,
          height: 48,
          p: 0,
          minWidth: 30,
          borderRadius: 0,
          backgroundColor: 'secondary.main'
        }}
        onClick={() => {
          handleSave();
        }}
      >
        <AddchartOutlined sx={{ fontSize: '14px' }} />
      </IconButton>
    </Tooltip>
  );
};

export default AddToDashboardButton;
